import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  OnChanges,
  SimpleChanges,
  AfterViewInit,
} from '@angular/core';
import { Components } from '@npm-bbta/bbog-dig-dt-webcomponents-lib';
import { IUserStorage } from '../../models/userStorage';
import { StorageService } from '../../services/storage/storage.service';
import { Customer } from '../../models/customer';

@Component({
  selector: 'app-drawer',
  templateUrl: './drawer.component.html',
  styleUrls: ['./drawer.component.scss'],
})
export class DrawerComponent implements OnChanges, AfterViewInit {
  @ViewChild('summaryDrawer') summaryDrawer!: ElementRef<Components.BdbMlDrawer>;
  @Input() sendLinks!: () => Promise<void>;
  @Output() closeComponent = new EventEmitter<void>();
  @Input() product: string;
  @Input() customer: Customer;
  @Input() informationLoading: boolean;
  @Input() advisorCostCenter: string;
  userStorage: IUserStorage;
  advisor: {
    idNumber: string;
    costCenter: string;
  };

  constructor(private readonly storageService: StorageService) {
    this.advisor = { idNumber: '', costCenter: '' };
  }

  ngAfterViewInit(): void {
    this.summaryDrawer.nativeElement.openDrawer();
    const { identificationNumber } = this.storageService.getUser();
    this.advisor = {
      ...this.advisor,
      idNumber: identificationNumber,
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['advisorCostCenter']?.currentValue) {
      this.advisor = this.advisor || { idNumber: '', costCenter: '' };
      this.advisor.costCenter = this.advisorCostCenter;
    }

    if (changes.customer) {
      this.summaryDrawer.nativeElement.openDrawer();
    }
  }

  drawerContinue(): void {
    if (this.sendLinks){
      this.sendLinks();
    }
  }

  closeDrawer(): void {
    this.summaryDrawer.nativeElement.closeDrawer();
    this.closeComponent.emit();
  }
}
